import { useEffect } from 'react';

/**
 * Google AdSense Component
 * 
 * Usage:
 * <AdSense 
 *   adClient="ca-pub-XXXXXXXXXX" 
 *   adSlot="1234567890"
 *   adFormat="auto"
 *   fullWidthResponsive={true}
 * />
 * 
 * Get your AdSense ID from: https://www.google.com/adsense/
 */
const AdSense = ({ 
  adClient = 'ca-pub-7250990909819942',
  adSlot,
  adFormat = 'auto',
  fullWidthResponsive = true,
  style = {}
}) => {
  useEffect(() => {
    try {
      if (window.adsbygoogle && process.env.NODE_ENV === 'production') {
        window.adsbygoogle.push({});
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  // Don't show ads in development
  if (process.env.NODE_ENV !== 'production') {
    return (
      <div 
        className="bg-slate-200 border-2 border-dashed border-slate-400 rounded-lg p-8 text-center"
        style={style}
      >
        <p className="text-slate-600 font-medium">AdSense Ad Placeholder</p>
        <p className="text-xs text-slate-500 mt-2">Ads will appear here in production</p>
      </div>
    );
  }

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', ...style }}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      data-full-width-responsive={fullWidthResponsive.toString()}
    />
  );
};

export default AdSense;